import { render, staticRenderFns } from "./FavCountries.vue?vue&type=template&id=5557d7e6&scoped=true"
import script from "./FavCountries.vue?vue&type=script&lang=js"
export * from "./FavCountries.vue?vue&type=script&lang=js"
import style0 from "./FavCountries.vue?vue&type=style&index=0&id=5557d7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5557d7e6",
  null
  
)

export default component.exports